import { ETableColumnAccessor } from './continuous';
export const TABLE_COLUMNS_DESCRIPTIONS = {
    [ETableColumnAccessor.Variant]: 'Variant ID: Chromosome-GRCh38 coordinate (position)-reference allele-alternate allele',
    [ETableColumnAccessor.VariantType]: 'SNV or indel',
    [ETableColumnAccessor.CollapsingModelName]: 'Genetic model',
    [ETableColumnAccessor.ConsequenceType]: 'Annotated consequence type',
    [ETableColumnAccessor.GeneName]: 'HGNC symbol of gene associated with annotated consequence',
    [ETableColumnAccessor.TranscriptId]: 'Ensembl ID of transcript associated with annotated consequence',
    [ETableColumnAccessor.CDNAChange]: 'cDNA change with respect to transcript',
    [ETableColumnAccessor.AAChange]: 'Amino acid change with respect to transcript',
    [ETableColumnAccessor.ExonRank]: 'Exon rank with respect to transcript',
    [ETableColumnAccessor.PValue]: 'P value',
    [ETableColumnAccessor.AAF]: 'Alternative allele frequency',
    [ETableColumnAccessor.EffectSize]: 'Effect size of transformed outcome',
    [ETableColumnAccessor.EffectSizeStandardError]: 'Effect size standard error',
    [ETableColumnAccessor.EffectSizeLCI]: 'Lower limit of the 95% confidence interval for the effect size',
    [ETableColumnAccessor.EffectSizeUCI]: 'Upper limit of the 95% confidence interval for the effect size',
};
